import React from 'react';
import { useSelector } from 'react-redux';

import AlertWarning from '../../shared/alertWarning.component';
import { currentPeriodSelector } from '../../shared/store/selectors';


type ImportInPreviousPeriodWarningProps = {
  jobResults: Record<string, any>,
  showWarning: boolean,
}

export const ImportInPreviousPeriodWarning = ({
  jobResults,
  showWarning = true,
}: ImportInPreviousPeriodWarningProps) => {
  const currentPeriod = useSelector(currentPeriodSelector);
  const currentPeriodName = currentPeriod?.name;
  const periodUsedInImport = jobResults?.jobMetadata?.periodName ?? null;

  const isImportFromPriorPeriod = currentPeriodName !== periodUsedInImport;

  if (!currentPeriodName || !periodUsedInImport || !isImportFromPriorPeriod || !showWarning) {
    return null;
  }

  const warningMessage = `Data will be imported in a ${periodUsedInImport} prior period`;

  return (
    <div className="py-3">
      <AlertWarning warningMessage={warningMessage} show />
    </div>
  );
};
